import React, { useState, useEffect, useRef, Suspense } from "react"
const PipsyForm = React.lazy(() => import("/components/Form"))
//import ReactMapboxGl, { Layer, Feature, GeoJSONLayer } from "react-mapbox-gl"
import * as mapboxgl from "mapbox-gl"
mapboxgl.accessToken =
	"pk.eyJ1IjoiYWFyb25jcmF3Zm9yZCIsImEiOiJja292ejc0ZDAwMTBmMnBsamlkbm04bHphIn0.8NAh0_UJZ38MJFtuKQSapQ"
import "mapbox-gl/dist/mapbox-gl.css"
import forEach from "lodash-es/forEach"
import _map from "lodash-es/map"
import find from "lodash-es/find"
import get from "lodash-es/get"
import debounce from "lodash-es/debounce"
import cloneDeep from "lodash-es/cloneDeep"
import styled, { css } from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEnvelopeOpen } from "@fortawesome/free-regular-svg-icons/faEnvelopeOpen"
import { faTimesCircle } from "@fortawesome/free-regular-svg-icons/faTimesCircle"
import { faMobileAlt } from "@fortawesome/free-solid-svg-icons/faMobileAlt"
import { useStoreState, useStoreActions } from "easy-peasy"
import { hb } from "/lib/hb.js"
import { wb } from "/lib/wb.js"
import * as dayjs from "dayjs"
import numeral from "numeral"
import markerColors from "/lib/markerColors"
import { scrollToMap, formatPhoneNumber, fireEvent } from "/lib/helpers"
//import CustomMarkers from "./CustomMarkers"
import "/scss/Mapbox.scss"

const MapWrapper = styled.div`
	position: relative;
	height: ${(props) => {
		if (props.isMobile && props.activePanel === false) {
			return "60vh"
		} else if (props.isMobile && props.activePanel === true) {
			return "30vh"
		}
		return "100%"
	}};
`
const Container = styled.div`
	opacity: ${(props) => (props.viewing == "amenities" || props.viewing == "area_features" ? 0 : 1)};
	border: 1px solid #ccc;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	background-color: white;
	transition: 0.3s opacity ease-out;
	display: ${(props) => (props.activePanel === false ? "block" : "none")};
	@media (min-width: 992px) {
		top: 15px;
		left: 15px;
		width: auto;
	}
`
const List = styled.ul`
	margin: 0;
	padding: 10px 20px;
	list-style: none;
	@media (min-width: 1200px) {
		display: flex;
	}
`
const Item = styled.li`
	color: #555;
	font-size: 13px;
	line-height: 1em;
	display: flex;
	align-items: center;
	margin-right: 15px;
	padding-bottom: 5px;
	@media (min-width: 992px) {
		padding-bottom: 0;
	}
`
const Swatch = styled.span`
	width: 15px;
	height: 15px;
	display: inline-block;
	margin-right: 10px;
	background-color: ${(props) => props.color};
`
const PitchContainer = styled.div`
	position: absolute;
	top: 65px;
	left: 15px;
	background-color: white;
	border-radius: 5px;
	display: none;
	align-items: center;
	border: 1px solid #ccc;
	@media (min-width: 1400px) {
		display: flex;
	}
`
const PitchBox = styled.div`
	display: flex;
	align-items: center;
	cursor: pointer;
	padding: 5px 10px;
	border-radius: 3px;
	background-color: ${(props) => (props.active ? "#3d465c" : "#fff")};
	svg {
		height: 15px;
		path {
			fill: ${(props) => (props.active ? "#fff" : "#3d465c")};
		}
	}
	span {
		font-size: 11px;
		padding-left: 5px;
		color: ${(props) => (props.active ? "#fff" : "#3d465c")};
	}
`

const PipsyMap = (props) => {
	let defaultThreeD = true
	if (get(props, `data.property.disabled.threeD`)) defaultThreeD = false
	const [mounted, setMounted] = useState(false)
	const flyBack = useStoreState((state) => state.flyBack)
	const unmatchedList = useStoreState((state) => state.unmatchedList)
	const domain = useStoreState((state) => state.domain)
	const pipsyClient = useStoreState((state) => state.pipsyClient)
	const propertyID = useStoreState((state) => state.propertyID)
	const setActiveLot = useStoreActions((actions) => actions.setActiveLot)
	const setContactOpen = useStoreActions((actions) => actions.setContactOpen)
	const setMobileContactOpen = useStoreActions((actions) => actions.setMobileContactOpen)
	const setActivePanel = useStoreActions((actions) => actions.setActivePanel)
	const setLotOpenType = useStoreActions((actions) => actions.setLotOpenType)
	const selectedAreaFeatures = useStoreState((state) => state.selectedAreaFeatures)
	const activeLot = useStoreState((state) => state.activeLot)
	const activePanel = useStoreState((state) => state.activePanel)
	const contactOpen = useStoreState((state) => state.contactOpen)
	const viewing = useStoreState((state) => state.viewing)
	const listHover = useStoreState((state) => state.listHover)
	const mode = useStoreState((state) => state.mode)
	const largeDevice = useStoreState((state) => state.largeDevice)
	const matchedList = useStoreState((state) => state.matchedList)
	const lastEvent = useStoreState((state) => state.lastEvent)
	const setLastEvent = useStoreActions((actions) => actions.setLastEvent)
	const setFlyBack = useStoreActions((actions) => actions.setFlyBack)
	const setViewing = useStoreActions((actions) => actions.setViewing)
	const showMap = useStoreState((state) => state.showMap)
	const [threeD, setThreeD] = useState(defaultThreeD)
	const [markers, setMarkers] = useState([])
	const [popups, setPopups] = useState([]) // only used in clicking from list to map
	const [areaFeaturesMarkers, setAreaFeaturesMarkers] = useState([])
	const [amenityMarkersLoaded, setAmenityMarkersLoaded] = useState(false)
	const [areaFeatureMarkersLoaded, setAreaFeatureMarkersLoaded] = useState(false)
	const markersRef = useRef(markers)
	const areaFeatureMarkersRef = useRef(areaFeaturesMarkers)
	let defaultColors = {
		takedown: "#1aa1ff",
		developer: "#e0e0e0",
		start: "#ffa03b",
		complete: "#00cf18",
		closed: "#e0e0e0",
		model: "#7a0b9e",
		lot: "#b5774e",
		premium: "#ff0000",
	}
	if (props?.data?.property?.customColors) {
		defaultColors = props.data.property.customColors
	}
	const [colors, setColors] = useState(defaultColors)
	const mapContainer = useRef(null)
	const [map, setMap] = useState(null)
	const [zoom, setZoom] = useState(15)
	const [activePitch, setActivePitch] = useState(false)
	const [geojson, setGeojson] = useState(null)
	const animationState = useRef({
		isAnimating: false,
		cancelAnimation: false,
		currentAnimation: null,
		opacity: 1,
		lastHoveredItem: null,
	})
	const [dotCoords, setDotCoords] = useState([0, 0])
	// If focusOn is set, set default to those coords, else just use the property coords
	// Focus on logic - set lat/lng to the lot's lat/lng if focusOn is in the URL
	let coords = {
		lat: props?.data?.property?.lat,
		lng: props?.data?.property?.lng,
	}
	try {
		let urlParams = new URLSearchParams(window.location.search)
		if (urlParams.get("focusOn")) {
			let lookupLot = find(props?.data?.mapLots, { id: parseInt(urlParams.get("focusOn")) })
			if (lookupLot.latitude && lookupLot.longitude) {
				coords.lat = lookupLot.latitude
				coords.lng = lookupLot.longitude
			}
		}
	} catch (e) {
		console.log(e)
	}
	const [lng, setLng] = useState(coords.lng)
	const [lat, setLat] = useState(coords.lat)

	let activeFrame = React.useRef()
	let dashRef = React.useRef()
	let noBuilder = props?.data?.property?.enabled?.noBuilder // This is for the likes of willowcreek, selling lots directly to prospects community wide

	const _setMarkers = (data) => {
		markersRef.current = data
		setMarkers(data)
	}

	const _setAreaFeaturesMarkers = (data) => {
		areaFeatureMarkersRef.current = data
		setAreaFeaturesMarkers(data)
	}

	let fillColors = [
		"case",
		["boolean", ["feature-state", "active"], false],
		"transparent",
		["==", ["get", "lot_status"], "Developer"],
		colors.developer,
		["==", ["get", "in_feed_manual"], false],
		colors.developer,
		["==", ["get", "model_show_in_feed"], true],
		colors.model,
		...(props?.data?.property?.enabled?.premiumHomesites
			? [["==", ["get", "is_premium"], true], colors.premium]
			: []),
		["==", ["get", "lot_status"], "Available Home"],
		colors.complete,
		["==", ["get", "lot_status"], "Available Lot"],
		colors.lot,
		["in", ["get", "lot_status"], ["literal", ["Closed", "Contract"]]],
		colors.closed,
		["==", ["get", "lot_status"], "Coming Soon"],
		colors.start,
		colors.developer,
	]

	const loadMap = () => {
		console.log(`Pipsy: Loading Map...isMobile: ${props.isMobile}`)
		const map = new mapboxgl.Map({
			container: mapContainer.current,
			style: threeD
				? "mapbox://styles/mapbox/standard"
				: "mapbox://styles/aaroncrawford/ckork89f3151q17p7jloy9p08",
			center: [lng, lat],
			pitch: 45,
			//bearing: 70,
			zoom: ["area_features", "amenities"].includes(viewing) ? 12 : 8,
			//minZoom: amenitiesStatus ? 11 : 14,
			minZoom: 10,
			//maxZoom: 18,
			attributionControl: false,
		}).addControl(
			new mapboxgl.AttributionControl({
				compact: false,
				customAttribution:
					'<a href="https://www.pipsy.io" target="_blank" style="font-weight:bold">&copy; Pipsy Inventory</a>',
			})
		)
		// Add navigation control (the +/- zoom buttons)
		if (!threeD) map.addControl(new mapboxgl.NavigationControl(), "bottom-right")
		let noBuilder = props?.data?.property?.enabled?.noBuilder
		map.on("move", () => {
			setLng(map.getCenter().lng.toFixed(4))
			setLat(map.getCenter().lat.toFixed(4))
			setZoom(map.getZoom().toFixed(2))
		})
		if (threeD) {
			map.on("style.load", () => {
				let hour = new Date().getHours()
				let style = "day" // the day style currently sucks, too blown out.
				// Time sensitive, uncomment below to enable - this was causing markers to not show when swtiching between 2d/3d, for future reference.
				/* if (hour >= 22 || hour <= 5) style = "night"
				else if (hour >= 5 && hour < 10) style = "dawn"
				else if (hour >= 10 && hour < 17) style = "dawn"
				else if (hour >= 17 && hour < 22) style = "dusk" */
				map.setConfigProperty("basemap", "lightPreset", style)
				map.setConfigProperty("basemap", "showPointOfInterestLabels", false)
			})
		}
		map.on("load", () => {
			try {
				if (props?.data?.property?.satellite) {
					map.addSource("aerial", {
						type: "raster",
						url: `mapbox://${props.data.property.satellite}`,
						//tileSize: 256,
					})
					map.addLayer({
						id: "aerial",
						type: "raster",
						source: "aerial",
						minzoom: 0,
						maxzoom: 22,
						paint: {
							//"raster-opacity": 0.8,
							//"raster-fade-duration": 0,
						},
						slot: "bottom",
					})
				}
			} catch (e) {
				console.log(e)
			}

			let data = geojson || buildGeoJson()
			//if (!threeD) map.setLayoutProperty("building-number-label", "visibility", "none")
			try {
				forEach(data.features, (v) => {
					let num = v.properties.address.split(" ")
					v.properties.street_number = num[0]
				})
			} catch (e) {
				console.error(e)
			}
			let centers = cloneDeep(data)
			centers = buildCenters(centers)
			map.addSource("lots", {
				type: "geojson",
				data,
			})
			map.addSource("streetNums", {
				type: "geojson",
				data: centers,
			})

			// Fill in the lots
			let fillOpacity = [
				"case",
				["boolean", ["feature-state", "active"], false],
				0,
				["boolean", ["feature-state", "hover"], false],
				1,
				["boolean", ["feature-state", "featureMatch"], false],
				1,
				["boolean", props?.data?.property?.enabled?.specAlwaysFullOpacity || false, true],
				0.7,
				["boolean", ["feature-state", "noFeatureMatch"], false],
				0.15,
				["==", ["get", "lot_status"], "Developer"],
				0.2,
				["==", ["get", "in_feed_manual"], false],
				0.2,
				["==", ["get", "model_show_in_feed"], true],
				0.8,
				["==", ["get", "lot_status"], "Available Home"],
				0.8,
				["in", ["get", "lot_status"], ["literal", ["Closed", "Contract"]]],
				0.2,
				["==", ["get", "lot_status"], "Coming Soon"],
				0.8,
				["==", ["get", "lot_status"], "Available Lot"],
				0.6,
				0.2,
			]
			if (noBuilder) {
				// no builder is willowcreek, selling dirt lots to prospects, so different colors and opacity
				fillOpacity = [
					"case",
					["boolean", ["feature-state", "active"], false],
					0,
					["==", ["get", "in_feed_manual"], false],
					0,
					["boolean", ["feature-state", "hover"], false],
					1,
					["==", ["get", "lot_status"], "Developer"],
					0.8,
					["==", ["get", "lot_status"], "Available Lot"],
					0.8,
					["==", ["get", "model_show_in_feed"], true],
					0.8,
					["in", ["get", "lot_status"], ["literal", ["Closed", "Contract"]]],
					0.2,
					0.2,
				]
				fillColors = [
					"case",
					["boolean", ["feature-state", "active"], false],
					"transparent",
					["in", ["get", "lot_status"], ["literal", ["Closed", "Contract"]]],
					colors.closed,
					["!=", ["get", "price"], null],
					colors.complete,
					colors.start,
				]
			}
			// Community outline
			if (get(props, `data.property.community_outline`)) {
				map.addSource("community_outline", {
					type: "geojson",
					data: props?.data?.property.community_outline,
				})
				let boundaryShade = get(props, `data.property.enabled.boundaryShade`)
				map.addLayer({
					id: "community_outline",
					type: "line",
					source: "community_outline",
					maxzoom: boundaryShade ? 20 : 13,
					slot: "bottom",
					paint: {
						"line-width": 3,
						"line-emissive-strength": 1,
						"line-color": props?.data?.property.color,
						"line-opacity": 0.5,
					},
				})
				if (boundaryShade) {
					map.addLayer({
						id: "community_outline_fill",
						type: "fill",
						slot: "bottom",
						source: "community_outline",
						maxzoom: boundaryShade ? 20 : 13,
						paint: {
							"fill-color": "#000000",
							"fill-opacity": 0.1,
						},
					})
				}
				// add a line layer with line-dasharray set to the first value in dashArraySequence
				map.addLayer({
					type: "line",
					source: "community_outline",
					id: "line-dashed",
					maxzoom: boundaryShade ? 20 : 13,
					paint: {
						"line-color": props?.data?.property.color,
						"line-emissive-strength": 1,
						"line-width": 2,
						"line-opacity": 0.5,
						"line-dasharray": [0, 4, 6],
					},
				})

				// technique based on https://jsfiddle.net/2mws8y3q/
				// an array of valid line-dasharray values, specifying the lengths of the alternating dashes and gaps that form the dash pattern
				const dashArraySequence = [
					[0, 4, 3],
					[0.5, 4, 2.5],
					[1, 4, 2],
					[1.5, 4, 1.5],
					[2, 4, 1],
					[2.5, 4, 0.5],
					[3, 4, 0],
					[0, 0.5, 3, 3.5],
					[0, 1, 3, 3],
					[0, 1.5, 3, 2.5],
					[0, 2, 3, 2],
					[0, 2.5, 3, 1.5],
					[0, 3, 3, 1],
					[0, 3.5, 3, 0.5],
				]
				let step = 0
				const animateDashArray = (timestamp) => {
					// Update line-dasharray using the next value in dashArraySequence. The
					// divisor in the expression `timestamp / 50` controls the animation speed.
					const newStep = parseInt((timestamp / 50) % dashArraySequence.length)
					if (newStep !== step) {
						map.setPaintProperty("line-dashed", "line-dasharray", dashArraySequence[step])
						step = newStep
					}
					// Request the next frame of the animation.
					dashRef.current = requestAnimationFrame(animateDashArray)
				}
				// start the animation
				animateDashArray(0)
			}
			map.addLayer({
				id: "lots",
				type: "fill",
				source: "lots",
				slot: "bottom",
				paint: {
					"fill-outline-color": "#FFFFFF",
					...(threeD && { "fill-emissive-strength": 0.9 }),
					"fill-color": fillColors,
					"fill-opacity": fillOpacity,
				},
			})
			// Section outlines
			if (get(props, `data.property.enabled.sectionOutlines`)) {
				// Need to create geojson for every neighborhood
				forEach(props?.data?.neighborhoods, (neigh) => {
					let data = {
						type: "FeatureCollection",
						features: [],
					}
					// Figure out all the sections with coordinates, and add them to the data.features array
					forEach(props.data.sections, (sec) => {
						if (sec.neighborhood_id === neigh.id && sec.coordinates) {
							data.features.push({
								type: "Feature",
								properties: {
									id: sec.id,
								},
								geometry: {
									type: "Polygon",
									coordinates: sec.coordinates,
								},
							})
						}
					})
					map.addSource(`section_outlines_${neigh.id}`, {
						type: "geojson",
						data,
					})
					map.addLayer({
						id: `section_outlines_${neigh.id}`,
						type: "line",
						slot: "bottom",
						source: `section_outlines_${neigh.id}`,
						//maxzoom: 13,
						paint: {
							/* "fill-color": neigh.color || "#ff0000",
							"fill-opacity": 0.3, */
							"line-color": neigh.color || "#ff0000",
							"line-emissive-strength": 1,
							"line-width": 5,
							"line-opacity": 0.5,
						},
					})
				})
				// Now add the text labels for the neighborhoods
				let neighborhoodLabels = {
					type: "FeatureCollection",
					features: [],
				}
				let neighLabelType = null
				//? Should be all labels or all logos, not a mix.  If that's requested modify this.
				forEach(props.data.neighborhoods, (n) => {
					if (n.logo) {
						map.loadImage(n.logo, (error, image) => {
							if (error) throw error

							// Add the image to the map's style
							const scaleFactor = 200 / image.width

							// Add the image to the map's style with the calculated scale
							map.addImage(`logo-${n.id}`, image, { sdf: false, pixelRatio: 1 / scaleFactor })

							// Add a point feature with the logo image
							map.addLayer({
								id: `logo-layer-${n.id}`,
								type: "symbol",
								source: {
									type: "geojson",
									data: {
										type: "FeatureCollection",
										features: [
											{
												type: "Feature",
												geometry: {
													type: "Point",
													coordinates: n.map_text_coords, // Specific coordinates for the logo
												},
											},
										],
									},
								},
								layout: {
									"icon-image": `logo-${n.id}`,
									"icon-size": ["interpolate", ["linear"], ["zoom"], 12, 0, 14, 0.5, 15, 0.8, 17, 1],
									"icon-allow-overlap": true,
									"icon-ignore-placement": true,
								},
							})
						})
					} else if (n.map_text_coords) {
						neighLabelType = "text"
						neighborhoodLabels.features.push({
							type: "Feature",
							properties: {
								description: n.name,
								logo: n.logo,
								color: n.color,
							},
							geometry: {
								type: "Point",
								coordinates: n.map_text_coords,
							},
						})
					}
				})
				if (neighLabelType === "text") {
					map.addSource("neighborhoodLabels", {
						type: "geojson",
						data: neighborhoodLabels,
					})
					map.addLayer({
						id: "neighborhoodLabels",
						type: "symbol",
						source: "neighborhoodLabels",
						slot: "top",
						//minzoom: 15,
						layout: {
							"text-field": ["get", "description"],
							//"text-variable-anchor": ["top", "bottom", "left", "right"],
							//"text-radial-offset": 0.5,
							//"text-justify": "auto",
							//"text-offset": [0, 1.25],
							//"text-anchor": "top",
							"text-size": 18,
							"text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
						},
						paint: {
							"text-color": ["get", "color"],
							"text-halo-color": "#fff",
							"text-halo-width": 3,
							"text-halo-blur": 5,
						},
					})
				}
			}
			// Add white line outlines
			map.addLayer({
				id: "lines",
				type: "line",
				source: "lots",
				paint: {
					"line-width": 2,
					"line-color": "#FFF",
					"line-opacity": 1,
				},
			})
			// Street numbers
			let textField = { "text-field": ["get", "street_number"] }
			if (props?.data?.property?.useLotNumbers) {
				textField = { "text-field": ["get", "lot"] }
			}
			map.addLayer({
				id: "streetNums",
				type: "symbol",
				source: "streetNums",
				slot: "bottom",
				minzoom: 17,
				layout: {
					...textField,
					"text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
					//"text-offset": [0, 1.25],
					//"text-anchor": "top",
					"text-size": 10,
				},
				paint: {
					"text-color": "#777",
				},
			})
			if (get(props, `data.property.amenities`) || get(props, `data.property.area_features`)) {
				// Big Marker for community
				let propName = get(props, `data.property.marketing_name`)
					? get(props, `data.property.marketing_name`)
					: get(props, `data.property.name`)
				let source_community_marker = {
					type: "FeatureCollection",
					features: [
						{
							type: "Feature",
							properties: {
								description: propName,
							},
							geometry: {
								type: "Point",
								coordinates: [get(props, `data.property.lng`), get(props, `data.property.lat`)],
							},
						},
					],
				}
				map.addSource("community_name", {
					type: "geojson",
					data: source_community_marker,
				})
				map.addLayer({
					id: "community_name",
					type: "symbol",
					source: "community_name",
					//minzoom: 15,
					layout: {
						"text-field": ["get", "description"],
						"text-variable-anchor": ["top", "bottom", "left", "right"],
						"text-radial-offset": 0.5,
						"text-justify": "auto",
						"text-allow-overlap": true,
						"text-offset": [0, 5.25],
						"text-anchor": "bottom",
						"text-size": 14,
						visibility:
							["area_features", "amenities"].includes(viewing) && !props?.data?.property?.logo
								? "visible"
								: "none",
					},
					paint: {
						"text-color": "#000",
					},
				})
			}
			if (get(props, `data.property.amenities`)) {
				// Amenities
				let amenities = []
				forEach(props?.data?.area_features, (v) => {
					if (v.amenity)
						amenities.push({
							type: "Feature",
							properties: {
								description: v.name,
							},
							geometry: {
								type: "Point",
								coordinates: [v.longitude, v.latitude],
							},
						})
				})
				let source_amenities = {
					type: "FeatureCollection",
					features: amenities,
				}
				map.addSource("amenities", {
					type: "geojson",
					data: source_amenities,
				})
				map.addLayer({
					id: "amenities",
					type: "symbol",
					source: "amenities",
					//minzoom: 15,
					layout: {
						"text-field": ["get", "description"],
						"text-variable-anchor": ["top", "bottom", "left", "right"],
						"text-radial-offset": 0.5,
						"text-justify": "auto",
						"text-offset": [0, 1.25],
						"text-anchor": "bottom",
						"text-size": 10,
						//cursor: "pointer",
						//visibility: "none",
					},
					paint: {
						"text-color": "#222",
					},
				})
				placeAmenityMarkers(map)
			}
			// Area features
			if (get(props, `data.property.area_features`)) {
				// Area features
				let area_features = []
				// area features first
				forEach(props?.data?.area_features, (v) => {
					if (!v.amenity)
						area_features.push({
							type: "Feature",
							properties: {
								description: v.name,
							},
							geometry: {
								type: "Point",
								coordinates: [v.longitude, v.latitude],
							},
						})
				})
				let source_area_features = {
					type: "FeatureCollection",
					features: area_features,
				}
				map.addSource("area_features", {
					type: "geojson",
					data: source_area_features,
				})
				let areaFeaturesVisiblity = ["area_features"].includes(viewing) ? "visible" : "none"
				if (props?.data?.property?.alwaysShowAreaFeatures) areaFeaturesVisiblity = "visible"
				map.addLayer({
					id: "area_features",
					type: "symbol",
					source: "area_features",
					//minzoom: 15,
					layout: {
						"text-field": ["get", "description"],
						"text-variable-anchor": ["top", "bottom", "left", "right"],
						"text-radial-offset": 0.5,
						"text-justify": "auto",
						"text-offset": [0, 1.25],
						"text-anchor": "top",
						"text-size": 10,
						visibility: areaFeaturesVisiblity,
					},
					paint: {
						"text-color": "#222",
					},
				})
			}

			if (viewing === "area_features" || props?.data?.property?.alwaysShowAreaFeatures) {
				// sometimes when mode is set this needs to fire right away, e.g evergreen area attractions
				placeAreaFeaturesMarkers(map)
			}

			let hoverID = null
			const popup = new mapboxgl.Popup({
				closeButton: false,
				className: "inventoryPopup",
				closeOnClick: false,
				maxWidth: "450px",
				offset: 25,
			}).addClassName("popupAboveLegend")
			let lastHoverFeature = null
			const removePopup = () => {
				popup.remove()
				lastHoverFeature = null
			}
			const addPopup = debounce((opts) => {
				if (opts.point.properties.id !== lastHoverFeature) {
					let lot = opts.point.properties
					let l
					if (lot.model && lot.model !== "null") l = find(props?.data?.models, { id: lot.id })
					else l = find(props?.data?.available, { id: lot.id })
					let acceptable = ["Available Home", "Available Lot", "Coming Soon", "Model"]
					if (!acceptable.includes(lot.lot_status) && !lot.model) {
						removePopup()
						return
					}
					lastHoverFeature = lot.id
					if (l) {
						//console.log(l)
						let center = coordinatesCenter(opts.coords)
						let html = ""
						html += `<div style="margin-bottom:5px;">`
						if (l.neighborhood) html += `<p class="inventoryPopup__neighborhood">${l.neighborhood}</p>`
						if (l.move_in_date && l.move_in_date > new Date().getTime() / 1000)
							html += `<p class="inventoryPopup__moveIn inventoryPopup__pill">Move-in: ${dayjs(
								l.move_in_date * 1000
							).format("MMMM D, YYYY")}`
						if (l.model) {
							html += `<p class="inventoryPopup__model inventoryPopup__pill">Model Home</p>`
						}
						html += `</p>`
						html += `</div>`
						if (l.address)
							html += `<p style="font-size:22px;font-weight:bold;margin:0;color:${props.theme.color}">${l.address}</p>`
						html += `<div style="display:flex;margin:7px 0;">`
						if (l.builder_marketing_name) {
							html += `<p style="font-size:13px;font-weight:bold;margin:0;color:#36394b">by ${l.builder_marketing_name}</p>`
						}
						if (l.lot_type) {
							// lot type pill
							html += `<p class="inventoryPopup__pill inventoryPopup__lotType">Lot Type: ${l.lot_type}</p>`
						}
						if (l?.floorplan?.feed_name || l?.floorplan?.name) {
							// fp pill
							let fpname = l?.floorplan?.feed_name || l?.floorplan?.name
							html += `<p class="inventoryPopup__pill inventoryPopup__floorplan">Plan: ${fpname}</p>`
						}
						html += `</div>`
						if (l.price)
							html += `<p style="font-size:14px;font-weight:bold;margin:8px 0;">${numeral(l.price).format(
								"$0,0"
							)}${
								l.lot_status
									? "<span style='font-weight:400;color:#666;font-size:13px'> | " +
									  l.lot_status +
									  "</span>"
									: ""
							}</p>`
						html += `<div class="inventoryPopup__stats">`
						if (l.sqft)
							html += `<span class="inventoryPopup__stat"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="inventoryPopup__icon"><path style="fill:${
								props.theme.color
							}" d="M0 32V448c0 35.3 28.7 64 64 64H480c17.7 0 32-14.3 32-32v-2.7c0-8.5-3.4-16.6-9.4-22.6l-51.3-51.3-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24-57.4-57.4-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24-57.4-57.4-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24-57.4-57.4-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24L131.3 83.3l-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24L57.4 9.4C51.4 3.4 43.2 0 34.7 0H32C14.3 0 0 14.3 0 32zM128 256L256 384H128V256z"/></svg>${numeral(
								l.sqft
							).format("0,0")} sqft</span>`
						if (l.beds)
							html += `<span class="inventoryPopup__stat"><svg class="inventoryPopup__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path style="fill:${props.theme.color}" d="M32 80c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48V209.1c-14.5-8.4-30.7-14-48-16.1c0-.3 0-.7 0-1V160c0-17.7-14.3-32-32-32H304c-17.7 0-32 14.3-32 32v32H240V160c0-17.7-14.3-32-32-32H112c-17.7 0-32 14.3-32 32v32c0 .3 0 .7 0 1c-17.3 2.2-33.6 7.8-48 16.1V80zM0 320c0-53 43-96 96-96H416c53 0 96 43 96 96V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V320z"/></svg>${l.beds} beds</span>`
						if (l.full_baths)
							html += `<span class="inventoryPopup__stat"><svg class="inventoryPopup__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path style="fill:${props.theme.color}" d="M64 131.9C64 112.1 80.1 96 99.9 96c9.5 0 18.6 3.8 25.4 10.5l16.2 16.2c-21 38.9-17.4 87.5 10.9 123L151 247c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-1.3 1.3c-35.5-28.3-84.2-31.9-123-10.9L170.5 61.3C151.8 42.5 126.4 32 99.9 32C44.7 32 0 76.7 0 131.9V448c0 17.7 14.3 32 32 32s32-14.3 32-32V131.9zM256 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"/></svg>${l.full_baths} baths</span>`
						if (l.stories)
							html += `<span class="inventoryPopup__stat" style="border-right:0;"><svg class="inventoryPopup__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path style="fill:${props.theme.color}" d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"/></svg>${l.stories} stories</span>`
						html += `</div>`
						let browserHeight = window.innerHeight
						if (l?.images?.[0] && browserHeight > 900) {
							html += `<div class="inventoryPopup__imageCont" style="min-height:200px;width:100%; position:relative; padding-top:56.25%;"><img src="${l.images[0]}" alt="" style="position:absolute; top:0; left:0; width:100%; height:100%; object-fit:cover;" /></div>`
						}
						popup.setLngLat([center.x, center.y]).setHTML(html).addClassName("popupAboveLegend").addTo(map)
					}
				}
			}, 80)
			map.on("mousemove", "lots", function (e) {
				try {
					if (props.isMobile) return
					let f = map.queryRenderedFeatures(e.point)[0]
					if (e.features.length > 0) {
						if (hoverID !== null) {
							map.setFeatureState({ source: "lots", id: hoverID }, { hover: false })
						}
						//setHoverID(e.features[0].id)
						hoverID = e.features[0].id
						map.setFeatureState({ source: "lots", id: hoverID }, { hover: true })
						let na = ["Closed", "Contract", "Developer"]
						let status = e.features[0].properties.lot_status

						let props = e.features[0].properties
						// Debugging
						/* if (e.features[0].properties.address == "1829 Indian Apple Way") {
							console.log(e)
							console.log(props)
						} */
						if (noBuilder) {
							if (["Contract", "Closed"].includes(status)) map.getCanvas().style.cursor = "not-allowed"
							else map.getCanvas().style.cursor = "pointer"
						} else {
							if (
								na.includes(status) ||
								(props.model && !props.model_show_in_feed) ||
								props.in_feed_manual === false
							) {
								map.getCanvas().style.cursor = "not-allowed"
							} else map.getCanvas().style.cursor = "pointer"
						}
						// popup
						addPopup({ point: f, coords: e.features[0].geometry.coordinates[0] })
					}
				} catch (e) {
					console.log(e)
				}
			})
			map.on("mousemove", function (e) {
				// Track the mouse movement, and if a popup is open and the user removes their mouse from a lot, then close the popup
				const feature = map.queryRenderedFeatures(e.point)
				if (Array.isArray(feature) && feature.length === 0 && lastHoverFeature) {
					removePopup()
				}
			})
			// When the mouse leaves the state-fill layer, update the feature state of the
			// previously hovered feature.
			map.on("mouseleave", "lots", function (e) {
				map.getCanvas().style.cursor = "default" // reset cursor back to hand
				if (hoverID !== null) {
					map.setFeatureState({ source: "lots", id: hoverID }, { hover: false })
				}
				hoverID = null
				removePopup()
			})
			map.on("click", "lots", (e) => {
				let lot = e.features[0].properties
				let na = ["Closed", "Contract", "Developer"]
				if (lot.model === "null") lot.model = null
				if (map.getLayer("flashing")) map.removeLayer("flashing")
				// If the lot is a model that is marked to not show in feed or if the lot is NA, then just leave
				if (
					(lot.model && !lot.model_show_in_feed) ||
					(lot.model && lot.model_show_in_feed === "null") ||
					lot.in_feed_manual === false
				)
					return
				else if (lot.model && lot.model_show_in_feed && !lot.sale_id) {
				} else if (noBuilder && !["Closed", "Contract"].includes(lot.lot_status)) {
				} else if (na.includes(lot.lot_status)) return
				//if(lot.builder == 'null') { return }
				let fullLot = find(props?.data?.available, {
					id: lot.id,
				})
				//console.log(fullLot)
				if (fullLot) {
					setActiveLot(fullLot)
				} else if (lot.model && lot.model_show_in_feed) {
					let model = find(props?.data?.models, { id: lot.id })
					setActiveLot(model)
				} else {
					if (lot.salespeople) lot.salespeople = JSON.parse(lot.salespeople)
					if (lot.marketing_salespeople) lot.marketing_salespeople = JSON.parse(lot.marketing_salespeople)
					setActiveLot(e.features[0].properties)
					if (props.isMobile) {
						let h = document.querySelector("#pipsyRoot").scrollHeight
						window.scrollTo(0, h)
					}
				}
				fireEvent(
					{
						type: "mapLotClick",
						data: lot.address,
						name: null,
					},
					lastEvent,
					setLastEvent,
					{ domain, pipsyClient, propertyID }
				)
				setLotOpenType("map")
				let openPanel = ["Available Home", "Coming Soon", "Available Lot"]
				if (openPanel.includes(lot.lot_status) || lot.model) setActivePanel(true)
				else if (noBuilder && !["Closed", "Contract"].includes(lot.lot_status)) setActivePanel(true)
				else setActivePanel(false)
				if (props.isMobile && (openPanel.includes(lot.lot_status) || lot.model)) {
					//window.scrollTo(0, 0)
				}
			})
			map.flyTo({
				center: [lng, lat],
				zoom: ["area_features", "amenities"].includes(viewing) ? 12 : zoom,
				//bearing: 0,
				pitch: 15, // Fly to the selected target
				duration: 2000,
				essential: true, // This animation is considered essential with
				//respect to prefers-reduced-motion
			})
			//? Pulsing dot
			const size = 135 // Increased from 100 to 150 (50% larger)
			const pulsingDot = {
				width: size,
				height: size,
				data: new Uint8Array(size * size * 4),
				onAdd: function () {
					const canvas = document.createElement("canvas")
					canvas.width = this.width
					canvas.height = this.height
					this.context = canvas.getContext("2d")
				},
				render: function () {
					const duration = 4000
					const t = (performance.now() % duration) / duration

					const radius = size / 5.33
					const outerRadius = (size / 2.67) * 0.7 * t + radius
					const context = this.context

					context.clearRect(0, 0, this.width, this.height)

					// Outer pulse
					context.beginPath()
					context.arc(this.width / 2, this.height / 2, outerRadius, 0, Math.PI * 2)
					context.fillStyle = `rgba(0, 150, 255, ${(1 - t) * animationState.current.opacity * 0.5})`
					context.fill()

					// Main dot
					context.beginPath()
					context.arc(this.width / 2, this.height / 2, radius, 0, Math.PI * 2)
					context.fillStyle = `rgba(0, 150, 255, ${animationState.current.opacity})`
					context.strokeStyle = `rgba(255, 255, 255, ${animationState.current.opacity})`
					context.lineWidth = 3
					context.fill()
					context.stroke()

					this.data = context.getImageData(0, 0, this.width, this.height).data
					map.triggerRepaint()
					return true
				},
			}
			map.addImage("pulsing-dot", pulsingDot, { pixelRatio: 2 })

			map.addSource("dot-point", {
				type: "geojson",
				data: {
					type: "FeatureCollection",
					features: [
						{
							type: "Feature",
							geometry: {
								type: "Point",
								coordinates: [0, 0],
							},
						},
					],
				},
			})

			map.addLayer({
				id: "layer-with-pulsing-dot",
				type: "symbol",
				source: "dot-point",
				layout: {
					"icon-image": "pulsing-dot",
					"icon-size": 0.675, // Increased from 0.5 to 0.75 (50% larger)
				},
			})
			//console.log(map.getStyle().layers)
			setMap(map)
			// This was causing react update state on unounted component
			/* fireEvent(
				{
					type: "mapLoad",
					data: true,
					name: null,
				},
				lastEvent,
				setLastEvent,
				{domain, pipsyClient, propertyID}			) */
		})
		map.on("zoom", () => {
			//console.log(map.getZoom())
		})

		//map.scrollZoom.disable()

		// Clean up on unmount
		return () => {
			console.log("Cleaning up Map unmount...")
			map.remove()
		}
	}

	useEffect(() => {
		// Mounts twice on load due to mobile/desktop
		/* console.log("PublicMap mounting with props:", {
			isMobile: props.isMobile,
			showMap,
			activePanel,
			viewing,
			activeLot: activeLot?.id,
		}) */
		// Change lot colors
		let c = cloneDeep(colors)
		if (get(props, `data.property.disabled.dirtLots`)) c.lot = c.developer
		setColors(c)
		setMounted(true)
		// Set lat/lng from property, but check focuson first
		return () => {
			console.log("PublicMap unmounting with props:", {
				isMobile: props.isMobile,
				showMap,
				activePanel,
				viewing,
				activeLot: activeLot?.id,
			})
		}
	}, [])

	useEffect(() => {
		if (mounted && !map) {
			loadMap()
		}
	}, [mounted])

	useEffect(() => {
		if (!mounted) return
		cancelAnimationFrame(activeFrame.current)
		cancelAnimationFrame(dashRef.current)
		//if(map) map.remove()
	}, [threeD])

	useEffect(() => {
		// For deep linking, fly to the lot if it's already set by deep.
		flyTo()
		colorLots()
		if (map && mode === "area_features") {
			setViewing("area_features")
		}
	}, [map])

	// On filter change, adjust opacity on matched vs unmatchedList elements
	useEffect(() => {
		colorLots()
	}, [matchedList])

	useEffect(() => {
		// New active lot
		if (viewing == "amenities" || viewing == "area_features") {
			flyTo()
			// clear existing popups
			forEach(popups, (v) => {
				v.remove()
			})
			let popup = buildPopup(activeLot)
			if (popup && map && activeLot) {
				popup.setLngLat([activeLot.longitude, activeLot.latitude]).addTo(map)
			}
			let pclone = cloneDeep(popups)
			pclone.push(popup)
			setPopups(pclone)
			return
		}
		// lot changed an it's not blank, fly to lot
		flyTo()
		// Mark the lot as colored
		if (!map || !activeLot.id || activeLot.builder == "null") return
		//map.removeFeatureState({ source: "lots" })
		//if (activeLot) map.removeFeatureState({ source: "lots" })
		if (viewing !== "floorplans") {
			map.setFeatureState({ source: "lots", id: activeLot.id }, { active: true })
		}
		// Add flashing layer if it doesn't exist
		// Active flashing layer
		flashLots()
		// Remove flashing dot
		map.setLayoutProperty("layer-with-pulsing-dot", "visibility", "none")
	}, [activeLot])

	useEffect(() => {
		// if a floorplan is clicked on the list, run floorplanColorLots
		if (viewing === "floorplans" && activeLot.id) {
			floorplanColorLots()
		}
		// Remove active lot
		//! Blank
		// lot changed and it's blank, zoom out and remove lots active feature states
		if (!map || activeLot.id) return
		map.removeFeatureState({ source: "lots" })
		map.flyTo({
			zoom: 15,
			essential: true,
		})
		cancelAnimationFrame(activeFrame.current)
		if (map.getLayer("flashing")) map.removeLayer("flashing")
		// Add back nofeaturematch's
		forEach(unmatchedList, (v) => {
			map.setFeatureState({ source: "lots", id: v.id }, { noFeatureMatch: true })
		})
	}, [activeLot])

	useEffect(() => {
		if (listHover?.latitude && listHover?.longitude && map) {
			handleListingHover(listHover.latitude, listHover.longitude)
		} else {
			cancelCurrentAnimation()
			fadeDot(false, 150)
		}
	}, [listHover])

	useEffect(() => {
		if (map) {
			if (contactOpen) map.scrollZoom.disable()
			else map.scrollZoom.enable()
		}
	}, [contactOpen])

	useEffect(() => {
		// This flies back to the properties center.  used so far in amenities
		if (flyBack && map) {
			map.flyTo({
				zoom: 15,
				center: [props?.data?.property.lng, props?.data?.property.lat],
				essential: true,
			})
			setFlyBack(false)
		}
	}, [flyBack])

	useEffect(() => {
		// When viewing amenities, add markers.  When not, remove markers
		try {
			if (map) {
				let amenities = get(props, `data.property.amenities`)
				let area_features = get(props, `data.property.area_features`)
				if (amenities) map.setLayoutProperty("community_name", "visibility", "none")
				if (viewing == "area_features") {
					if (area_features) {
						map.setLayoutProperty("area_features", "visibility", "visible")
						if (!props?.data?.property?.logo)
							map.setLayoutProperty("community_name", "visibility", "visible")
						else if (map.getLayer("logo")) map.setLayoutProperty("logo", "visibility", "visible")
					}
					map.flyTo({
						zoom: 12,
						center: [props?.data?.property.lng, props?.data?.property.lat],
					})
					placeAreaFeaturesMarkers(map)
				} else if (viewing == "amenities") {
					if (!props?.data?.property?.alwaysShowAreaFeatures) {
						if (area_features) {
							map.setLayoutProperty("area_features", "visibility", "none")
							map.setLayoutProperty("community_name", "visibility", "none")
						}
						wipeAreaFeaturesMarkers()
					}

					map.flyTo({
						zoom: 14,
						center: [props?.data?.property.lng, props?.data?.property.lat],
					})
				} else {
					if (area_features && !props?.data?.property?.alwaysShowAreaFeatures) {
						map.setLayoutProperty("area_features", "visibility", "none")
						map.setLayoutProperty("community_name", "visibility", "none")
						if (map.getLayer("logo")) map.setLayoutProperty("logo", "visibility", "none")
						wipeAreaFeaturesMarkers()
					}
					setFlyBack(true)
				}
			}
		} catch (e) {
			console.log(e)
		}
	}, [viewing])

	useEffect(() => {
		if (!map) return
		wipeAreaFeaturesMarkers()
		placeAreaFeaturesMarkers(map)
	}, [selectedAreaFeatures])

	const flashLots = (line) => {
		// line is for debug purposes to figure out where the function is being called from
		if (!map || viewing === "floorplans") return
		if (!map.getLayer("flashing")) {
			//console.log("Flashing..", line)
			let filter = ["==", "id", activeLot.id]
			if (!activeLot && listHover) {
				// if there's an active lot it should always prioritize flashing
				filter = ["==", "id", listHover.id]
			}
			let fillColors = [
				// This is specifically for flashing, has to be different than normal fill
				"case",
				["==", ["get", "model_show_in_feed"], true],
				colors.model,
				...(props?.data?.property?.enabled?.premiumHomesites
					? [["==", ["get", "is_premium"], true], colors.premium]
					: []),
				["==", ["get", "lot_status"], "Available Home"],
				colors.complete,
				["in", ["get", "lot_status"], ["literal", ["Closed", "Contract"]]],
				colors.closed,
				["==", ["get", "lot_status"], "Coming Soon"],
				colors.start,
				["==", ["get", "lot_status"], "Available Lot"],
				colors.lot,
				[">", ["get", "takedown_date"], 0],
				colors.lot,
				["==", ["get", "takedown"], false],
				colors.developer,
				colors.developer,
			]
			if (noBuilder) {
				fillColors = [
					"case",
					["in", ["get", "lot_status"], ["literal", ["Closed", "Contract"]]],
					colors.closed,
					["!=", ["get", "price"], null],
					colors.complete,
					colors.start,
				]
			}
			map.addLayer({
				id: "flashing",
				type: "fill",
				source: "lots",
				slot: "bottom",
				filter,
				paint: {
					"fill-color": fillColors,
					"fill-opacity": 1,
					...(threeD && { "fill-emissive-strength": 0.9 }),
				},
			})
			var opacityUp = true
			var animOpacity = 0.1
			var animStep = 0.01
			let animateLot = () => {
				if (opacityUp) {
					animOpacity += animStep
					if (animOpacity >= 0.75) {
						opacityUp = false
					}
				} else {
					animOpacity -= animStep
					if (animOpacity <= 0.1) {
						opacityUp = true
					}
				}
				// Sometimes frame is too quick and goes over 1, so adjust
				if (animOpacity > 1) animOpacity = 1
				activeFrame.current = requestAnimationFrame(animateLot)
				if (map.getLayer("flashing")) map.setPaintProperty("flashing", "fill-opacity", animOpacity)
				//if (threeD) map.setPaintProperty("flashing", "fill-emissive-strength", animOpacity)
			}
			animateLot()
		}
	}

	const colorLots = () => {
		if (!map) return
		if (viewing !== "floorplans") {
			// Using ID on new devs with low lot id #,s this was matching floorplan ids, not lot ids.
			map.removeFeatureState({ source: "lots" })
			forEach(unmatchedList, (v) => {
				map.setFeatureState({ source: "lots", id: v.id }, { noFeatureMatch: true })
			})
			if (activeLot) {
				//? This was commented out for some reason.  It's purpose is when deep linking to a lot, it should be flashing.
				map.setFeatureState({ source: "lots", id: activeLot.id }, { active: true })
				flashLots()
			}
		}
	}

	const floorplanColorLots = () => {
		//? User clicks a floorplan in the list, color the lots that this plan can go on by looking at lot types and builder
		//TODO Could add anti-monotony here.
		if (!map) return
		if (activeLot) {
			let fp = activeLot
			let lots = get(props, `data.mapLots`)
			let types = []
			forEach(fp.lot_types, (v) => {
				if (v.property === parseInt(props.data.property.id)) {
					types.push(v.lot_type)
				}
			})
			if (lots) {
				forEach(lots, (v) => {
					if (v.builder_id === fp.builder_id && types.includes(v.lot_type_id)) {
					} else {
						map.setFeatureState({ source: "lots", id: v.id }, { noFeatureMatch: true })
					}
				})
			}
		}
	}

	const wipeAreaFeaturesMarkers = () => {
		if (props?.data?.property?.alwaysShowAreaFeatures) return
		let marks = [...areaFeatureMarkersRef.current]
		marks.forEach((marker) => {
			marker.remove()
		})
		_setAreaFeaturesMarkers([])
	}

	const buildPopup = (v) => {
		let image = ""
		if (v.image) image = `<img src="${v.image}" />`
		let name = `<p class="title">${v.name}</p>`
		if (v.url) {
			name = `<p class="title"><a href="${v.url}" target="_blank">${v.name}</a></p>`
		}
		let description = ""
		if (v.description) description = `<p class="description">${v.description}</p>`
		const popup = new mapboxgl.Popup({ offset: 25, className: "mapboxPopup" }).setHTML(
			`<div>${image}${name}${description}<p class="category">${v.category}</p></div>`
		)
		return popup
	}

	let placeAmenityMarkers = (map) => {
		let marks = []
		forEach(props?.data?.area_features, (v) => {
			if (!v.amenity) return
			//if (!CustomMarkers[v.category]) return
			if (!selectedAreaFeatures.includes(v.category)) return
			/* let mark = new Image(20, 20)
			if (!amenityMarkersLoaded) {
				mark.onload = () => map.addImage(v.name, mark)
			}
			mark.src = CustomMarkers[v.category] */
			let popup = buildPopup(v)
			let marker = new mapboxgl.Marker({
				//element: mark,
				//anchor: 'top',
				color: markerColors[v.category] || "#FF0000",
				scale: 0.8,
				offset: [0, -15],
			})
				.setLngLat([v.longitude, v.latitude])
				.setPopup(popup)
				.addTo(map)
			marks.push(marker)
		})

		setAmenityMarkersLoaded(true)
		_setMarkers(marks)
	}

	let placeAreaFeaturesMarkers = (map) => {
		// Includes the community marker
		let marks = []
		forEach(props?.data?.area_features, (v) => {
			if (v.amenity) return
			if (!selectedAreaFeatures.includes(v.category)) return
			let popup = buildPopup(v)
			let marker = new mapboxgl.Marker({
				//element: mark,
				//anchor: 'top',
				color: markerColors[v.category] || "#FF0000",
				scale: 0.8,
				offset: [0, -15],
			})
				.setLngLat([v.longitude, v.latitude])
				.setPopup(popup)
				.addTo(map)
			marks.push(marker)
		})
		// Community colored marker
		let prop = get(props, `data.property`)
		// If the "always show area features on", we dont need the map marker for the community, as it's always on the map
		if (!props?.data?.property?.alwaysShowAreaFeatures) {
			if (prop?.logo) {
				if (!map.hasImage("logo")) {
					map.loadImage(prop.logo, (error, image) => {
						if (error) throw error

						// Add the image to the map style.
						map.addImage("logo", image)

						// Add a data source containing one point feature.
						map.addSource("logo", {
							type: "geojson",
							data: {
								type: "FeatureCollection",
								features: [
									{
										type: "Feature",
										geometry: {
											type: "Point",
											coordinates: [prop.lng, prop.lat],
										},
									},
								],
							},
						})

						// Add a layer to use the image to represent the data.
						map.addLayer({
							id: "logo",
							type: "symbol",
							source: "logo",
							layout: {
								"icon-image": "logo", // reference the image
								"icon-size": 0.5,
							},
							visibility:
								["area_features", "amenities"].includes(viewing) && prop.logo ? "visible" : "none",
						})
					})
				}
			} else {
				let marker = new mapboxgl.Marker({
					//element: mark,
					anchor: "top",
					color: prop.color || "#FF0000",
					scale: 1.5,
					offset: [0, -35],
				})
					.setLngLat([prop.lng, prop.lat])
					//.setPopup(popup)
					.addTo(map)
				marks.push(marker)
			}
		}

		setAreaFeatureMarkersLoaded(true)
		_setAreaFeaturesMarkers(marks)
	}

	let flyTo = () => {
		if (!map || !activeLot.id || !activeLot.longitude || !activeLot.latitude) return
		colorLots()
		let flyZoom = 18
		let curve = 1.42
		if (viewing == "amenities" || viewing == "area_features") {
			flyZoom = 16
			curve = 1
		}
		let lat = activeLot.latitude
		if (props.isMobile && activePanel) {
			// Since the map is loaded in on mobile with 60vh (at writing), and the panel is now 40vh due to active panel, shift the lat down slightly to get the lot in the center of the 40vh frame.
			lat = lat - 0.0005
		}
		map.flyTo({
			zoom: flyZoom,
			curve,
			center: [activeLot.longitude, lat],
			essential: true,
		})
		// Remove active flashing layer and cancel animation, then load the new lot.  Put in in case you click a lot, then click another lot...need to stop the old one.
		cancelAnimationFrame(activeFrame.current)
		if (map.getLayer("flashing")) map.removeLayer("flashing")
	}

	let buildGeoJson = () => {
		let model = {
			type: "FeatureCollection",
			crs: {
				type: "name",
				properties: {
					name: "urn:ogc:def:crs:OGC:1.3:CRS84",
				},
			},
			features: [],
		}
		// Since we delete coordinates, clone this so if mobile/desktop change we still have coords.
		let set = cloneDeep(props?.data?.mapLots)
		forEach(set, (v) => {
			if (!v.coordinates || !v.coordinates.length) {
				return
			}
			let coords = v.coordinates
			delete v.coordinates
			model.features.push({
				geometry: {
					coordinates: coords,
					type: "Polygon",
				},
				properties: v,
				id: v.id,
				type: "Feature",
			})
		})
		setGeojson(model)
		return model
	}

	const coordinatesCenter = (arr) => {
		let tmp = {
			lx: null,
			hx: null,
			ly: null,
			hy: null,
		}

		forEach(arr, (v) => {
			if (v[0] < tmp.lx || !tmp.lx) {
				tmp.lx = v[0]
			}
			if (v[0] > tmp.hx || !tmp.hx) {
				tmp.hx = v[0]
			}

			if (v[1] < tmp.ly || !tmp.ly) {
				tmp.ly = v[1]
			}
			if (v[1] > tmp.hy || !tmp.hy) {
				tmp.hy = v[1]
			}
		})
		let center = {}
		center.x = tmp.lx + (tmp.hx - tmp.lx) / 2
		center.y = tmp.ly + (tmp.hy - tmp.ly) / 2
		return center
	}

	let buildCenters = (data) => {
		// Mapbox's getCenter method wasn't producing good results.
		forEach(data.features, (v) => {
			const center = coordinatesCenter(v.geometry.coordinates[0])
			v.geometry = {
				type: "Point",
				coordinates: [center.x, center.y],
			}
			return v
		})

		return data
	}

	let openContact = () => {
		if (largeDevice) {
			setContactOpen(true)
		} else {
			setMobileContactOpen(true)
		}
	}

	let closePanel = () => {
		setActiveLot(false)
		setActivePanel(false)
		setMobileContactOpen(false)
		setContactOpen(false)
	}
	const cancelCurrentAnimation = () => {
		try {
			animationState.current.cancelAnimation = true
			if (animationState.current.currentAnimation) {
				cancelAnimationFrame(animationState.current.currentAnimation)
			}
		} catch (e) {
			console.log(e)
		}
	}

	const easeOutCubic = (t) => {
		return 1 - Math.pow(1 - t, 3)
	}

	const animateDot = (startCoords, endCoords, duration = 1000) => {
		return new Promise((resolve, reject) => {
			try {
				cancelCurrentAnimation()
				animationState.current.cancelAnimation = false

				const start = performance.now()
				const animate = (time) => {
					if (animationState.current.cancelAnimation) {
						reject(new Error("Animation cancelled"))
						return
					}

					const elapsed = time - start
					const progress = Math.min(elapsed / duration, 1)
					const eased = easeOutCubic(progress)

					const currentLng = startCoords[0] + (endCoords[0] - startCoords[0]) * eased
					const currentLat = startCoords[1] + (endCoords[1] - startCoords[1]) * eased

					map.getSource("dot-point").setData({
						type: "FeatureCollection",
						features: [
							{
								type: "Feature",
								geometry: {
									type: "Point",
									coordinates: [currentLng, currentLat],
								},
							},
						],
					})

					if (progress < 1) {
						animationState.current.currentAnimation = requestAnimationFrame(animate)
					} else {
						resolve()
					}
				}

				animationState.current.currentAnimation = requestAnimationFrame(animate)
			} catch (e) {
				console.log(e)
			}
		})
	}

	const shakeDot = (coords, duration = 1000, shakeDistance = 0.0001, repetitions = 3) => {
		return new Promise((resolve, reject) => {
			try {
				cancelCurrentAnimation()

				const start = performance.now()
				const originalLng = coords[0]
				const originalLat = coords[1]

				const animate = (time) => {
					const elapsed = time - start
					const progress = elapsed / duration

					if (progress < 1) {
						const repetitionProgress = (progress * repetitions) % 1
						const shakeProgress = Math.sin(repetitionProgress * Math.PI * 2)

						const shakeLng = originalLng + shakeProgress * shakeDistance
						const shakeLat = originalLat + shakeProgress * shakeDistance * 0.5

						map.getSource("dot-point").setData({
							type: "FeatureCollection",
							features: [
								{
									type: "Feature",
									geometry: {
										type: "Point",
										coordinates: [shakeLng, shakeLat],
									},
								},
							],
						})

						animationState.current.currentAnimation = requestAnimationFrame(animate)
					} else {
						map.getSource("dot-point").setData({
							type: "FeatureCollection",
							features: [
								{
									type: "Feature",
									geometry: {
										type: "Point",
										coordinates: [originalLng, originalLat],
									},
								},
							],
						})
						resolve()
					}
				}
				animationState.current.currentAnimation = requestAnimationFrame(animate)
			} catch (e) {
				console.log(e)
			}
		})
	}

	const fadeDot = (fadeIn, duration = 300, coordinates = null) => {
		return new Promise((resolve) => {
			cancelCurrentAnimation()
			animationState.current.cancelAnimation = false

			if (fadeIn) {
				// For fade in, immediately set the opacity to 1 and resolve
				animationState.current.opacity = 1
				if (coordinates) {
					map.getSource("dot-point").setData({
						type: "FeatureCollection",
						features: [
							{
								type: "Feature",
								geometry: {
									type: "Point",
									coordinates: coordinates,
								},
							},
						],
					})
				}
				map.setLayoutProperty("layer-with-pulsing-dot", "visibility", "visible")
				resolve()
				return
			}

			const start = performance.now()
			const initialOpacity = animationState.current.opacity
			const targetOpacity = 0

			const animate = (time) => {
				if (animationState.current.cancelAnimation) {
					resolve()
					return
				}

				const progress = Math.min((time - start) / duration, 1)
				animationState.current.opacity = initialOpacity + (targetOpacity - initialOpacity) * progress

				if (coordinates) {
					map.getSource("dot-point").setData({
						type: "FeatureCollection",
						features: [
							{
								type: "Feature",
								geometry: {
									type: "Point",
									coordinates: coordinates,
								},
							},
						],
					})
				}

				if (progress < 1) {
					animationState.current.currentAnimation = requestAnimationFrame(animate)
				} else if (map) {
					map.setLayoutProperty("layer-with-pulsing-dot", "visibility", "none")
					resolve()
				}
			}

			animationState.current.currentAnimation = requestAnimationFrame(animate)
		})
	}

	const handleListingHover = async (lat, lng) => {
		try {
			//if (animationState.current.lastHoveredItem === `${lat},${lng}`) return
			animationState.current.lastHoveredItem = `${lat},${lng}`

			cancelCurrentAnimation()
			animationState.current.isAnimating = true

			// Set the dot's opacity to 1 and make it visible immediately
			animationState.current.opacity = 1
			map.setLayoutProperty("layer-with-pulsing-dot", "visibility", "visible")

			// Animate the dot from the current position to the new position
			await animateDot(dotCoords, [lng, lat], 500)

			// Shake the dot at the new position
			await shakeDot([lng, lat], 500, 0.0001, 2)
		} catch (error) {
			console.log("Animation cancelled:", error)
		}

		setDotCoords([lng, lat])
		animationState.current.isAnimating = false
	}

	let ContactDrawer = () => {
		if (!contactOpen) return ""
		const Drawer = styled.div`
			background-color: rgba(255, 255, 255, 0.95);
			padding: 0 0 10px 0;
			position: absolute;
			z-index: 1100;
			bottom: 10vh;
			width: 90%;
			min-height: 50vh;
			border-right: 1px solid #ccc;
			transition: left 1s;
			display: flex;
			flex-direction: column;
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
			${hb.md`
				box-shadow:0;
			`}
		`
		const Title = styled.div`
			font-size: 22px;
			background-color: ${(props) => props.theme.color || "black"};
			padding: 20px;
			color: white;
			margin: 0;
			padding-right: 100px;
			position: relative;
		`
		const Salesperson = styled.div`
			padding: 10px 20px;
			background-color: white;
			color: #222;
			border-bottom: 1px solid #ccc;
			font-size: 13px;
			display: grid;
			grid-template-columns: repeat(20, 1fr);
			a {
				color: #222;
				display: inline-block;
				padding-left: 10px;
				padding-right: 20px;
				text-decoration: none;
			}
		`
		const SalespersonName = styled.span`
			display: flex;
			align-items: center;
			padding-right: 20px;
			grid-column: span 4;
		`
		const SalespersonContact = styled.span`
			grid-column: span 8;
			display: flex;
			align-items: center;
		`
		const FormContainer = styled.div`
			display: flex;
			justify-content: center;
			height: 100%;
			flex: 1;
		`
		const Close = styled.div`
			position: absolute;
			right: 15px;
			top: 15px;
			cursor: pointer;
		`
		return (
			<Drawer>
				<Title className="pipsy__formTitle">
					{["homes", "models", "lot_finder"].includes(viewing) ? activeLot.address : activeLot.name}
					<Close onClick={() => setContactOpen(false)}>
						<FontAwesomeIcon icon={faTimesCircle} color={"white"} />
					</Close>
				</Title>
				{activeLot.marketing_salespeople &&
					activeLot.marketing_salespeople.length > 0 &&
					_map(activeLot.marketing_salespeople, (v) => {
						return (
							<Salesperson key={v.name}>
								<SalespersonName>{v.name}</SalespersonName>
								{v.phone && (
									<SalespersonContact
										onClick={() => {
											fireEvent(
												{
													type: "phoneSalesperson",
													data: v.phone,
													name: activeLot.address,
												},
												lastEvent,
												setLastEvent,
												{ domain, pipsyClient, propertyID }
											)
										}}>
										{" "}
										<FontAwesomeIcon icon={faMobileAlt} color={props.theme.lightGray} />
										<a href={`tel:${v.phone}`}>{formatPhoneNumber(v.phone)}</a>
									</SalespersonContact>
								)}
								{v.email && !props?.data?.property?.disabled?.showEmails && (
									<SalespersonContact
										onClick={() => {
											fireEvent(
												{
													type: "emailSalesperson",
													data: v.email,
													name: activeLot.address,
												},
												lastEvent,
												setLastEvent,
												{ domain, pipsyClient, propertyID }
											)
										}}>
										{" "}
										<FontAwesomeIcon icon={faEnvelopeOpen} color={props.theme.lightGray} />
										<a href={`mailto:${v.email}`}>{v.email}</a>
									</SalespersonContact>
								)}
							</Salesperson>
						)
					})}
				<FormContainer>
					<Suspense fallback={<div>Loading...</div>}>
						<PipsyForm data={props.data} theme={props.theme} custom={props?.data?.custom} />
					</Suspense>
				</FormContainer>
			</Drawer>
		)
	}

	let Legend = () => {
		if (get(props, `data.property.disabled.legend`)) return ""
		let moveInText = "Ready for Move-In"
		if (props?.data?.custom?.renameKey?.moveIn) moveInText = props?.data?.custom?.renameKey?.moveIn
		let data = (
			<List>
				{!get(props, `data.property.disabled.dirtLots`) && (
					<Item>
						<Swatch color={colors.lot} /> Available Homesite
					</Item>
				)}
				<Item>
					<Swatch color={colors.complete} /> {moveInText}
				</Item>
				<Item>
					<Swatch color={colors.start} /> Available Home Under Construction
				</Item>
				<Item>
					<Swatch color={colors.model} /> Model Home
				</Item>
				{get(props, `data.property.customColors.premium`) && (
					<Item>
						<Swatch color={colors.premium} /> Premium Homesite
					</Item>
				)}
				{!get(props, `data.property.disabled.unavailableLegend`) && (
					<Item>
						<Swatch color={colors.closed} /> Unavailable
					</Item>
				)}
			</List>
		)
		if (noBuilder) {
			// selling dirt lots, so only (as of now) available
			data = (
				<List>
					<Item>
						<Swatch color={colors.complete} /> Available Homesite
					</Item>
					<Item>
						<Swatch color={colors.start} /> Coming Soon
					</Item>
					<Item>
						<Swatch color={colors.closed} /> Unavailable
					</Item>
				</List>
			)
		}
		return (
			<Container viewing={viewing} activePanel={activePanel}>
				{data}
			</Container>
		)
	}

	const PitchControl = () => {
		if (props?.data?.property?.enabled?.pitchControl) {
			return (
				<PitchContainer>
					<PitchBox
						active={activePitch}
						onClick={() => {
							if (map.getPitch() === 0) {
								setActivePitch(false)
								map.easeTo({ pitch: 45, duration: 1000 })
							} else {
								setActivePitch(true)
								map.easeTo({ pitch: 0, duration: 1000 })
							}
						}}>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
							<path d="M253.3 67.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2l-208 400c-3.9 7.4-3.6 16.4 .8 23.5S15.6 480 24 480l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L63.5 432 253.3 67.1zM242 175.5l-22.6 43.4c19.3 15.8 36.5 34 51.3 54.1l40.8-25.6c-19.6-27.2-43-51.4-69.5-71.9zM322.7 392l48.8 0c-6-36.9-18-71.8-34.7-103.8l-40.8 25.6c12.4 24.3 21.5 50.6 26.8 78.2z" />
						</svg>
					</PitchBox>
				</PitchContainer>
			)
		}
		return ""
	}

	if (props?.data?.property) {
		return (
			<MapWrapper isMobile={props.isMobile} activePanel={activePanel}>
				<div ref={mapContainer} className="" style={{ height: "100%", width: "100%" }} />
				<Legend colors={colors} />
				<PitchControl />
				{<ContactDrawer />}
				{/* <ThreeD /> */}
			</MapWrapper>
		)
	}
	return <MapWrapper></MapWrapper>
}

export default PipsyMap
